module.exports = __webpack_public_path__ + "static/img/logo.4e1642d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 93
// module chunks = 1